module.exports = __webpack_public_path__ + "img/administracao-icon.7c2141d8.png";